export const useGetData = async () => {
  const token = useCookie('token_refresh')
  const config = useRuntimeConfig()

  return await useFetch<ApiResponse>(config.public.serverApi + '/api/v1/driver/login', {
    method: 'POST',
    body: {
      token,
    },
    transform(input) {
      return {
        ...input,
        fetchedAt: new Date(),
      }
    },
    getCachedData(key, nuxtApp) {
      const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      if (!data) {
        return
      }

      const expirationDate = new Date(data.fetchedAt)
      // Кешируем данные на 1 минуту
      expirationDate.setTime(expirationDate.getTime() + 60 * 1000)
      const isExpired = expirationDate.getTime() < Date.now()
      if (isExpired) {
        return
      }

      return data
    },
    dedupe: 'defer',
  })
}
